import { render, staticRenderFns } from "./DetailPPN.vue?vue&type=template&id=6dd06772&"
import script from "./DetailPPN.vue?vue&type=script&lang=js&"
export * from "./DetailPPN.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports